// Modules
import React, { useCallback } from 'react';
import _ from 'lodash';

import { FormCard } from 'components/content-containers/cards';
import { Page, PageContent, PageHeader } from 'components/page';
import SVG from 'components/widgets/icons/svg';
import MfaDevice from 'services/data/mfa-device';
import MfaDeviceForm from './components/mfa-device-form';
import appHistory from 'app-history';

import { useMfaDevice } from './hooks/use-mfa-device';


// Component
export default function MfaDeviceEdit({ routeParams }) {
  const deviceId = routeParams && routeParams.deviceId;
  const { data: device, isLoading } = useMfaDevice(deviceId);

  const onSubmit = useCallback((values) => {
    const update = _.clone(values);

    return MfaDevice.update(update)
      .then(() => {
        appHistory.push('/mfa');
      });
  }, []);

  if (isLoading || !device) return null;

  const initialValues = _.pick(device, ['id', 'name', 'host', 'description', 'team']);

  return (
    <Page>
      <PageHeader title="Edit MFA Device" />
      <PageContent className="bg-medium-blue-grey">
        <div className="form-summary flex flex-equal-children">
          <FormCard className="mfa-device-form">
            <div className="form-header">
              <SVG src="svg/cog.svg" className="cog" />
              <h5 className="form-title">Edit MFA Device</h5>
            </div>
            <MfaDeviceForm
              initialValues={initialValues}
              onSubmit={onSubmit}
            />
          </FormCard>
        </div>
      </PageContent>
    </Page>
  );
}
